export default __webpack_public_path__ + "static/media/headerGif2.041b3894.gif";